import { useState } from 'react';
import icons_eye from '../../assets/icons_eye.svg';
/* eslint-disable-next-line */
export interface InputPasswordProps {
    label: string;
    name: string;
    value: string;
    onChange: (value: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur: (value: React.ChangeEvent<HTMLInputElement>) => void;
    error?: boolean;
    errorMessage?: string;
    className?: string;
}

export function InputPassword(props: InputPasswordProps) {
    const [showPass, setShowPass] = useState(false);
    return (
        <div className={`${props.className ? props.className : 'mb-4'} relative`}>
            <label className="mb-2 block text-sm" htmlFor="password">
                {props.label}
            </label>
            <input
                type={showPass ? 'text' : 'password'}
                name={props.name}
                className={`input-base ${props.error && 'border-red-500 focus:border-red-500 hover:border-red-700'}`}
                value={props.value}
                onChange={props.onChange}
                onBlur={props.onBlur}
            />
            <img
                className={`absolute right-3 ${props.error ? 'bottom-8' : 'bottom-2'}`}
                src={icons_eye}
                onClick={() => setShowPass((prevState) => !prevState)}
                alt="icon-eye"
            />
            {props.error && <p className="text-red-500 text-xs mt-2">{props.errorMessage}</p>}
        </div>
    );
}

export default InputPassword;
